import { ApiCallParams } from "@/services/baseService";
import config from "@/services/config";
import store from "@/store/index";
import {
  LoginUserVm,
  postLoginData,
  postRegistrationData,
  UserRegistrationVm,
  postFinishRegistrationCodeApi,
  postTwoFactorLoginCode
} from "@/services/authentication";
import { userIsAuthorize } from "@/services/JWTservice";
import router from "@/router";
import routing from "@/constants/routes";
import actions from "./actions";
import { isAlive } from "@/services/accounts";
import routes from "@/constants/routes";

export default {
  actions: {
    async [actions.LOGIN](ctx?: any, params?: ApiCallParams<LoginUserVm>) {
      if (params !== undefined) {
        const response = await postLoginData(params);
        if (response) {
          if (response.notFinishedRegistration) {
            router.push({ path: routing.CONFIRMREG });
            ctx.commit("updateUserPhone", response.phone);
            ctx.commit("changeNotFinishedRegistration", true);
          } else if (response.twoFactorAuth) {
            router.push({ path: routing.TWO_FACTOR_LOGIN });
            ctx.commit("updateUserPhone", response.phone);
          } else {
            window.sessionStorage.setItem(
              config.apiTokenStorageKey,
              response.token
            );
            ctx.commit("updateAuthorizeStatus", true);
            router.push({ path: routing.DASHBOARD });
          }
        }
        ctx.commit("updateIsLoginButtonLoadingMutation", false);
      }
    },

    async [actions.TWO_FACTOR_LOGIN](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        const response = await postTwoFactorLoginCode(params);
        if (response) {
          window.sessionStorage.setItem(
            config.apiTokenStorageKey,
            response.token
          );
          ctx.commit("updateAuthorizeStatus", true);
          router.push({ path: routing.DASHBOARD });
        }
        ctx.commit("updateIs2FALoginButtonLoadingMutation", false);
      }
    },

    async [actions.REGISTER](
      ctx?: any,
      params?: ApiCallParams<UserRegistrationVm>
    ) {
      if (params !== undefined) {
        const response = await postRegistrationData(params);
        if (response) {
          ctx.commit("updateUserPhone", response.phone);
          router.push({ path: routing.CONFIRMREG });
        }
        ctx.commit("updateIsRegistrationProceedButtonLoadingMutation", false);
      }
    },

    async [actions.FINISH_REGISTRATION](
      ctx?: any,
      params?: ApiCallParams<string>
    ) {
      if (params !== undefined) {
        const token = await postFinishRegistrationCodeApi(params);
        if (token !== undefined) {
          window.sessionStorage.setItem(config.apiTokenStorageKey, token);
          ctx.commit("updateAuthorizeStatus", true);
          ctx.commit("changeNotFinishedRegistration", true);
          router.push({ path: routing.DASHBOARD });
        }
        ctx.commit("updateIsConfirmRegistrationButtonLoadingMutation", false);
      }
    },

    [actions.LOGOUT]() {
      sessionStorage.removeItem(config.apiTokenStorageKey); // clear your user's token from sessionStorage
      router.push({ path: routing.LOGIN });
    },

    async [actions.POST_IS_ALIVE](ctx?: any) {
      console.log("actions.POST_IS_ALIVE");
      console.log(
        "store.getters.getKeepAliveStatus == " +
          store.getters.getKeepAliveStatus
      );

      if (!store.getters.getKeepAliveStatus) {
        console.log("set changeKeepAliveStatus = true");
        ctx.commit("changeKeepAliveStatus", true);

        // check if session is not expired every 'checkAlive' seconds
        const refreshIntervalId: number = setInterval(async () => {
          const isSessionActive = await isAlive();
          console.log("isSessionActive: " + isSessionActive);
          if (!isSessionActive) {
            // stop setInterval function
            console.log("clearInterval(refreshIntervalId)");
            clearInterval(refreshIntervalId);

            console.log("set changeKeepAliveStatus = false");
            ctx.commit("changeKeepAliveStatus", false);

            console.log("remove JWT from storage");
            // clear your user's token from sessionStorage
            window.sessionStorage.removeItem(config.apiTokenStorageKey);

            // set user as not authenticated
            ctx.commit("updateAuthorizeStatus", isSessionActive);

            // and open LOGIN page
            console.log("open LOGIN page");

            if (router.currentRoute.path != routes.LOGIN) {
              router.push({ path: routing.LOGIN });
            }
          }
        }, 5000);
      }
    },

    async [actions.CHECK_IF_AUTHORIZED](ctx?: any) {
      const isAuth = await userIsAuthorize();
      ctx.commit("updateAuthorizeStatus", isAuth);
    }
  },

  mutations: {
    updateAuthorizeStatus(state?: any, isAuth?: boolean) {
      state.isAuth = isAuth;
    },
    updateUserPhone(state?: any, phone?: string) {
      state.phone = phone;
    },
    changeKeepAliveStatus(state?: any, enabled?: boolean) {
      state.keepAliveRunning = enabled;
    },
    changeNotFinishedRegistration(
      state?: any,
      notFinishedRegistration?: boolean
    ) {
      state.notFinishedRegistration = notFinishedRegistration;
    }
  },

  state: {
    isAuth: false,
    phone: "",
    keepAliveRunning: false,
    notFinishedRegistration: false
  },

  getters: {
    getAuthStatus(state?: any) {
      return state.isAuth;
    },

    getKeepAliveStatus(state?: any) {
      return state.keepAliveRunning;
    },

    getNotFinishedRegistration(state?: any) {
      return state.notFinishedRegistration;
    }
  }
};
